import React, {
  FunctionComponent,
  SVGAttributes,
  useMemo,
  Suspense,
} from 'react'
import iconMap from '@/components/HeroIcons/icon-map'
import { useTheme } from '@emotion/react'
import { IconTypes } from '@/components/HeroIcons/icon-types'

const EmptyIcon = () => <div />

interface PropsIcon extends SVGAttributes<HTMLElement> {
  name: IconTypes
  size?: string
  width?: string
  height?: string
  themeColor?: [string, string]
  ariaLabel?: string
}

const Icon: FunctionComponent<PropsIcon> = ({
  name,
  size = '20px',
  width = '',
  height = '',
  themeColor = ['primary', '500'],
  ariaLabel,
  ...rest
}) => {
  const theme = useTheme()
  const Icon = iconMap[name] || EmptyIcon
  const style = useMemo(() => {
    const realSize: { width: string; height: string } = {
      width: 'unset',
      height: 'unset',
    }
    if (width || height) {
      if (width) realSize.width = width
      if (height) realSize.height = height
      return realSize
    }
    return { width: size, height: size }
  }, [height, size, width])
  return (
    <Suspense fallback={<i />}>
      <Icon
        css={{ color: theme.colors[themeColor[0]][themeColor[1]] }}
        style={style}
        themeColor={themeColor}
        aria-label={ariaLabel}
        {...rest}
      />
    </Suspense>
  )
}

export default Icon
